export default "__VITE_ASSET__BWeJBmTZ__"